import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function WorkflowSetup() {

    return (
        <div>
            <DHeader>Setting up the Workflow</DHeader>
       
            <DCode>
                {`flow = Flow("ECommerce Order Flow")

flow.add_node(order_parser_node)
flow.add_node(agent)
flow.add_node(invoice_generator_node)
flow.add_node(agent_output_parser_node)

flow.add_edge("START", "OrderParser|extract_order")
flow.add_edge("OrderParser|extract_order", "BillingAgent|run_agent")
flow.add_edge("BillingAgent|run_agent", "AgentOutputParser|parse_agent_output")
flow.add_edge("AgentOutputParser|parse_agent_output", "InvoiceGenerator|generate_invoice")
flow.add_edge("InvoiceGenerator|generate_invoice", "END")

#data connections

flow.add_data_source("OrderParser|extract_order|text", "INPUTS|text")

flow.add_data_source("BillingAgent|run_agent|task", "OrderParser|extract_order|order")

flow.add_data_source("AgentOutputParser|parse_agent_output|order_str", "BillingAgent|run_agent|agent_output")

flow.add_data_source("InvoiceGenerator|generate_invoice|items", "AgentOutputParser|parse_agent_output|items")
flow.add_data_source("InvoiceGenerator|generate_invoice|total", "AgentOutputParser|parse_agent_output|total")
flow.add_data_source("InvoiceGenerator|generate_invoice|tax", "AgentOutputParser|parse_agent_output|tax")


flow.set_outputs(['InvoiceGenerator|generate_invoice|invoice_text'])
        `}
            </DCode>
       
        </div>
    )
}